import '../../../assets/css/stock_listing.css'
import react, { useState, useEffect } from "react";

import { makeStyles } from '@mui/styles';
import { useHistory } from "react-router-dom";
import HistoryIcon from '@mui/icons-material/History';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import DownloadIcon from '@mui/icons-material/Download';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import AddIcon from '@mui/icons-material/Add';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view'
import Add_to_stock_modal from '../add_to_stock/add_stock_modal/add_stock_modal';
import { view_stock, verify_products_existance_in_stock, delete_from_stock } from '../../../services/stock_service';
import Import_to_stock_modal from '../add_to_stock/import_to_stock_modal/import_to_stock_modal';
import { get_suppliers, get_categories_forAll_services, get_directions } from '../../../services/for_allServices';
import StockSearch from '../search/StockSearch';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Stock_transactions_table from '../transactions/Stock_transactions_table';

import swal from 'sweetalert';
import Add_fixed_asset_modal from '../set_assets/add_as_fixed_asset';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    deleteIcon: {
        color: 'red',
        cursor: 'pointer'
    },
    icon: {
        cursor: 'pointer'
    }
});

const columns = [
    { id: 'product_code', label: "Reference du produit", minWidth: 0 },
    { id: 'product_name', label: "Produit de référence", minWidth: 0 },
    { id: 'product_category', label: "Famille d'achat", minWidth: 0 },
    { id: 'product_quantity', label: "Quantité", minWidth: 0 },
    { id: 'products_by_suppliers', label: "Produits", minWidth: 0 }
];

const Stock_data = react.memo(({ stock_data, get_category_name_by_id, get_supplier_by_id, view_product_details, handleDeleteClick, openFixedAssetModal }) => {
    const classes = useStyles();

    return (
        <>
            {
                stock_data.map((product, id_stock_product) => (
                    <TableRow key={"product " + id_stock_product}>
                        <TableCell>
                            {product.product_reference}
                        </TableCell>
                        <TableCell> {product.product_name} </TableCell>
                        <TableCell> {get_category_name_by_id(product.product_category)} </TableCell>
                        <TableCell> {product.product_quantity} </TableCell>
                        <TableCell width={700}>
                            <div className='products_by_supplier_header'>
                                <div className='products_by_supplier_infos_container'>
                                    <div className='product_code'>Code produit</div>
                                    <div className='product_supplier'>Fournisseur</div>
                                    <div className='product_quantity'>Quantité</div>
                                    <div className='product_quantity'>Archivé</div>

                                    <div className='product_price'>Prix</div>
                                    <div className='product_price'></div>
                                </div>
                            </div>
                            {product.products_by_supplier.map((products_by_supplier, id_products_by_supplier) => (
                                <div className='products_by_supplier_infos' key={"product_infos " + id_stock_product + "_" + id_products_by_supplier}>
                                    <div className='products_by_supplier_infos_container'>
                                        <div className='product_code'>
                                            <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={() => view_product_details(product, id_stock_product, id_products_by_supplier)}>
                                                {products_by_supplier.product_code}
                                            </span>
                                        </div>
                                        <div className='product_supplier'>{products_by_supplier.supplier ? get_supplier_by_id(products_by_supplier.supplier) : "Aucun"}</div>
                                        <div className='product_quantity'>{products_by_supplier.product_quantity}</div>
                                        <div className='product_quantity'>{products_by_supplier.archived ? "oui" : "non"}</div>

                                        <div className='product_price'>{products_by_supplier.product_price}</div>
                                        <div className='product_price'>
                                            {/* <Tooltip title="Déclarer Immo">
                                                <DatasetLinkedIcon className={classes.icon} onClick={() => openFixedAssetModal(products_by_supplier)} />
                                            </Tooltip> */}
                                            <Tooltip title="Archiver">
                                                <DeleteForeverIcon className={classes.deleteIcon} onClick={() => handleDeleteClick({ product_reference: product.product_reference, product_code: products_by_supplier.product_code })} />
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    )
})

// const DeleteConfirmationDialog = ({ open, handleClose, handleConfirm }) => {
//     return (
//         <Dialog
//             open={open}
//             onClose={handleClose}
//             maxWidth="sm" fullWidth
//         >

//             <DialogTitle >{"Confirmation de suppression"}</DialogTitle>
//             <DialogContent>
//                 <DialogContentText >
//                     Voulez-vous vraiment supprimer ce fournisseur ?
//                 </DialogContentText>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={handleClose} color="primary">
//                     Annuler
//                 </Button>
//                 <Button onClick={handleConfirm} variant='contained' color="error" autoFocus>
//                     Oui
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

const Stock_listing = () => {

    const classes = useStyles();
    let history = useHistory();
    const [url_updated, setUrl_updated] = useState(null);
    const [waiting, setWaiting] = useState(false);

    const [stock_data, setStock_data] = useState(null);

    const [directions, setdirections] = useState([]);
    const [departments, setdepartments] = useState([]);
    const [suppliers, setsuppliers] = useState([]);
    const [categories, setCategories] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(10);
    const [data_count, setdata_count] = useState(0);

    const [update_product_infos, setupdate_product_infos] = useState(null);
    const [open_fixed_asset_modal, setopen_fixed_asset_modal] = useState(null);

    const [open_addProduct_to_stock_modal, setopen_addProduct_to_stock_modal] = useState(false);
    const [open_importProducts_to_stock_modal, setopen_importProducts_to_stock_modal] = useState(false);
    const [openTransactionsDialog, setOpenTransactionsDialog] = useState(false);

    useEffect(() => {
        get_directions().then((response) => {
            setdirections(response.data);
        }).catch((error) => {
           //  console.log(error.response);
        });
    }, [])
    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const page = urlParams.get('page') ? urlParams.get('page') : 1;

        setCurrentPage(Number(page));
        load_stock_data(page);

        const load_data = async () => {
            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page);
            await get_suppliers().then((response) => {
               //  console.log("load_data : ", response.data);
                setsuppliers(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            })
            await get_categories_forAll_services().then((response) => {
                setCategories(response.data);
            }).catch((error) => {
                //console.log(error.response);
            });
            await load_stock_data(page);
        }
        load_data();



    }, [url_updated]);

    async function load_stock_data(page) {
        await view_stock(page).then((response) => {
           //  console.log("stock", response.data);
            setStock_data(response.data.data);
            setdata_count(response.data.total)
        }).catch((error) => {
           //  console.log(error.response);
        })
    }

    async function verify_product_by_code_in_stock(products_codes) {
        const formData = new FormData();
        formData.append("products_codes", JSON.stringify(products_codes))
        let product_infos = await verify_products_existance_in_stock(formData).then((response) => {
           //  console.log("verify_products_existance_in_stock :code", response.data);
            return response.data;
        }).catch((error) => {
           //  console.log(error.response)
        })
        return product_infos;
    }

    async function verify_product_by_reference_in_stock(products_references) {
        const formData = new FormData();
        formData.append("products_references", JSON.stringify(products_references))
        let product_infos = await verify_products_existance_in_stock(formData).then((response) => {
           //  console.log("verify_products_existance_in_stock : refrence", response.data);
            return response.data;
        }).catch((error) => {
           //  console.log(error.response)
        })
        return product_infos;
    }


    async function view_product_details(product, id_stock_product, id_products_by_supplier) {
        setupdate_product_infos({ "product": product, "id_stock_product": id_stock_product, "id_products_by_supplier": id_products_by_supplier });
        setopen_addProduct_to_stock_modal(true);
    }


    async function handleClose_importProducts_to_stock_modal() {
        //   setStock_data(null);
        setopen_importProducts_to_stock_modal(false);
        await load_stock_data();
    }


    async function handleClose_addProduct_to_stock_modal() {
        //setStock_data(null);
        setupdate_product_infos(null);
        setopen_addProduct_to_stock_modal(false);
        await load_stock_data();
    }

    function get_category_name_by_id(id_category) {
        let tmp_name = "";
        for (let category of categories) {
            if (category.id_category == parseInt(id_category)) tmp_name = category.name;
        }
        return tmp_name;
    }


    function get_supplier_by_id(id) {
        // //  console.log("suppli")
        let tmp_supplier = "";
        for (let supplier of suppliers) {
            if (supplier.id == id) { tmp_supplier = supplier.parentCompany; break; }
        }
        return tmp_supplier;
    }


    const handleSearchResults = (filteredData) => {
       //  console.log(filteredData.data);

        setStock_data(filteredData.data.data);

    };

    const handleDelete = async (deletePayload) => {
        swal({
            title: "Confirmer l'archivage",
            text: "Êtes-vous sûr de vouloir archiver ce fournisseur ?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (isConfirm) => {
            if (isConfirm) {
                try {
                   //  console.log("reference", deletePayload.product_reference, "code", deletePayload.product_code);
                    const response = await delete_from_stock(deletePayload);
                   //  console.log("message", response.data);

                    await load_stock_data();

                    swal("Archivé !", "Le fournisseur a été archivé avec succès.", "success");
                } catch (error) {
                    console.error("Erreur lors de la suppression :", error.response);
                    swal("Erreur", "L'archivage a échoué.", "error");
                }
            }
        });
    };

    const handleDeleteClick = (payload) => {
        handleDelete(payload); // appelle directement la confirmation swal
    };


    async function change_page(page) {
        setCurrentPage(page); // Mise à jour de la page
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;

        if (!params) {
            history.push(path + "?page=" + page);
        } else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    search_params[i] = "page=" + page;
                }
            }
            tmp_params = path + "?" + search_params.join('&');
            if (!tmp_params.includes("page=")) {
                tmp_params += "&page=" + page;
            }
            history.push(tmp_params);
        }

        // Appelle directement la fonction pour recharger les données après le changement de page
        await load_stock_data(page);
    }

    const handleOpenTransactionsHistory = () => {
        setOpenTransactionsDialog(true);
    };

    const handleCloseTransactionsHistory = () => {
        setOpenTransactionsDialog(false);
    };

    function openFixedAssetModal(product) {
        setopen_fixed_asset_modal(product);
    }


    return (
        <>
            {
                stock_data == null
                    ? <Loading_animation_view />
                    : <div className='stock_list_container'>
                        <div className="products_gallery_header_container">
                            <div style={{ marginRight: '7px', display: 'flex' }}>
                                <Tooltip title="Ajouter">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setopen_addProduct_to_stock_modal(true)} >
                                        <AddIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>

                                <Tooltip title="Importer">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setopen_importProducts_to_stock_modal(true)}>
                                        <DownloadIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>
                                <Tooltip title="Historique des transactions">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" >
                                        <HistoryIcon className="my_icon" onClick={handleOpenTransactionsHistory} />
                                    </Fab>
                                </Tooltip>
                            </div>
                            <StockSearch categories={categories}
                                onSearch={handleSearchResults}
                                loadStockData={load_stock_data}
                            />
                        </div>
                        <div className="commissions_table_container">
                            <TableContainer>
                                <Table className={classes.table} aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {
                                                columns.map((column) => (
                                                    <TableCell key={column.id} align="left">{column.label}</TableCell>
                                                ))
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            stock_data.length !== 0
                                                ?
                                                <>
                                                    <Stock_data key={"stock_data"} stock_data={stock_data} get_category_name_by_id={get_category_name_by_id} get_supplier_by_id={get_supplier_by_id}
                                                        view_product_details={view_product_details} handleDeleteClick={handleDeleteClick} openFixedAssetModal={openFixedAssetModal} />
                                                </>

                                                : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun produit disponible</div>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {
                                stock_data.length !== 0
                                    ? <div className="pagination_container">
                                        <Pagination
                                            activePage={Number(currentPage)}
                                            itemsCountPerPage={dataPerPage}
                                            totalItemsCount={Number(data_count)}
                                            pageRangeDisplayed={4}
                                            onChange={change_page.bind(this)}
                                        />
                                    </div>
                                    : <></>
                            }
                        </div>
                    </div>
            }
            {
                open_addProduct_to_stock_modal == true
                    ? <Add_to_stock_modal categories={categories} key={"add_popup"} open_addProduct_to_stock_modal={open_addProduct_to_stock_modal} handleClose_addProduct_to_stock_modal={handleClose_addProduct_to_stock_modal}
                        suppliers={suppliers} update_product_infos={update_product_infos} verify_product_by_code_in_stock={verify_product_by_code_in_stock} verify_product_by_reference_in_stock={verify_product_by_reference_in_stock} />
                    : <></>
            }
            {
                open_importProducts_to_stock_modal == true
                    ? <Import_to_stock_modal open_importProducts_to_stock_modal={open_importProducts_to_stock_modal} handleClose_importProducts_to_stock_modal={handleClose_importProducts_to_stock_modal}
                        categories={categories} suppliers={suppliers} verify_product_by_code_in_stock={verify_product_by_code_in_stock} verify_product_by_reference_in_stock={verify_product_by_reference_in_stock} />
                    : <></>
            }
            {
                openTransactionsDialog == true
                    ? <Stock_transactions_table open={openTransactionsDialog} categories={categories} suppliers={suppliers} onClose={handleCloseTransactionsHistory} />
                    : <></>
            }

            {
                open_fixed_asset_modal != null
                    ? <Add_fixed_asset_modal
                        open_fixed_asset_modal={open_fixed_asset_modal}
                        onClose={() => setopen_fixed_asset_modal(null)}
                        suppliers={suppliers}
                        assetCategories={categories} // si tu as un référentiel
                        directions={directions}
                        departments={departments}
                        onCreated={(data) => {
                            // refresh list / toast etc.
                           //  console.log("Created fixed assets:", data);
                        }}
                    /> : <></>
            }






            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}


export default Stock_listing;